import React from "react";
import {
  CheckboxInputField,
  checkboxValidation,
  multipleValidations,
} from "@jsainsburyplc/id-ui-common";

import { Link } from "@jsluna/link";

import {
  TERMS_AND_CONDITIONS,
  TERMS_REQUIRED,
} from "constants/registrationForm";

import SectionContainer from "./SectionContainer";

const MyDetails = ({ termsData: { label } }) => (
  <SectionContainer label={label}>
    <CheckboxInputField
      data-testid="terms-and-conditions"
      name={TERMS_AND_CONDITIONS}
      validation={multipleValidations([checkboxValidation(TERMS_REQUIRED)])}
      info={
        "We want you to know exactly how our service works and why we need your registration details. Please state that you have read and agreed to these terms before you continue."
      }
      checkboxLabel={
        <span>
          I agree to the{" "}
          <Link
            href="https://help.sainsburys.co.uk/help/terms-and-conditions/buying-online"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms and conditions
          </Link>
        </span>
      }
    />
  </SectionContainer>
);

export default MyDetails;
